import Model from '@/models/Model.js';

export default class GradingSchemeCriteria extends Model {
    static entity = 'grading_scheme_criterias';

    static modelName = 'GradingSchemeCriteria';

    static fields() {
        return {
            id: this.attr(null),
            grading_scheme_criteria_template_id: this.attr(null),
            grading_scheme_id: this.attr(null),
            name: this.attr(null),
            minimum: this.attr(null),
            is_minimum_passing: this.attr(null),

            ...super.fields(),

            grading_scheme: this.belongsTo('grading_schemes', 'grading_scheme_id'),
        };
    }
}
